import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { IconButton } from '@material-ui/core'
import AppsIcon from '@mui/icons-material/Apps'

const ExcelExport = ({ data, columns, fileName }) => {
    const exportToExcel = async () => {
        // Create a new workbook and worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        // filter out hidden columns from the columns array
        const visibleColumns = columns.filter(col => !col.hidden);

        // map columns to worksheet columns
        worksheet.columns = visibleColumns.map(col => ({
          header: col.title,
          key: col.field
        }));

        // Add data rows, ensuring to map the data to the correct columns and remove any columns which are hidden
        data.forEach(item => {
          const row = visibleColumns.map(col => {
            return item[col.field] || ''; // Use the field name to get the value from the item
          });
          worksheet.addRow(row);
        });

        // Generate Excel file as a buffer
        const buffer = await workbook.xlsx.writeBuffer();
    
        // Create a Blob from the buffer and save the file
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, fileName || 'download.xlsx');
      }; 
    
    return (
        <IconButton onClick={exportToExcel} fontSize="large" aria-label="export to excel">
            <AppsIcon />
        </IconButton>
    );
}

export default ExcelExport;
